import { AgreementStatus } from "./SupplierAdminPOSTypes";

export function isReadyForAgreementStatus(status: AgreementStatus | undefined) {
    return status !== undefined &&
        status !== AgreementStatus.AWAITING_T_AND_C
}

export function isReadyForIndustryCodes(status: AgreementStatus | undefined) {
    switch (status) {
        case undefined:
        case AgreementStatus.AWAITING_T_AND_C:
        case AgreementStatus.REJECTED:
            return false
        default:
            return true
    }
}

export function isReadyForBankAccounts(status: AgreementStatus | undefined) {
    return status === AgreementStatus.VALID
}

export function showHostedOnboardingButton(status: AgreementStatus) {
    return status !== AgreementStatus.VALID &&
        status !== AgreementStatus.REJECTED
}

export function isReadyForHostedOnboarding(status: AgreementStatus) {
    switch (status) {
        case AgreementStatus.AWAITING_T_AND_C:
        case AgreementStatus.CREATE_BUSINESS_LINES:
            return false
        default:
            return true
    }
}

export function hasAdyenApplicationBegun(status: AgreementStatus) {
    switch (status) {
        case AgreementStatus.AWAITING_T_AND_C:
        case AgreementStatus.CREATE_BUSINESS_LINES:
        case AgreementStatus.START:
            return false
        default:
            return true
    }
}
